import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

//UI
import { FaExclamationCircle } from 'react-icons/fa';
//SLICE
import { initialStateParent, getParentThunk, activateParentAccountThunk } from '../../../store/slices/public/parents.slice';
import { getConfigsThunk, initialStateConfig } from '../../../store/slices/catalogs/config.slice';
import { API_BASE_URL } from '../../../store/constans';
import MainLoader from '../../../components/Loaders/MainLoader';

const ActivateAccountPublic = () => {
  const dispatch = useDispatch();
  const { parent_id } = useParams();
  const { item, message, procesing, error } = useSelector(state => state.parents);
  const { items } = useSelector(state => state.configurations);
  const isLoading = useSelector(state => state.isLoadingSlice);

  useEffect(() => {
    dispatch(getParentThunk(parent_id));
    dispatch(getConfigsThunk());
    return () => {
      dispatch(initialStateParent());
      dispatch(initialStateConfig())
    }
  }, []);

  const onSubmit = () => {
    dispatch(activateParentAccountThunk(parent_id));
  }

  return (
    <>
      {isLoading ? (<MainLoader />) : (
        <div
          className={`text-gray-600 p-2 md:p-0 flex justify-center items-center 2xl:items-center h-full w-full min-h-screen bg-cover bg-center`}
          style={{ backgroundImage: `url(${API_BASE_URL + items[0]?.background})` }}
        >
          <div className="absolute top-0 left-0 w-full h-full bg-zinc-800/40 "></div>
          <div className="w-full md:w-[35%] h-screen md:h-auto bg-white/80 backdrop-blur-sm shadow-md shadow-gray-800 flex flex-col items-center justify-center rounded-md z-10">
            <div className='flex mb-[-20px] flex-col gap-2 w-full items-center justify-center p-4'>
              <img className='w-[280px] md:w-[180px]' src={API_BASE_URL + items[0]?.logo} alt="logo" />
              <h1 className="text-lg text-sky-700">Activación de cuenta de usuario </h1>
            </div>
            {error &&
              <div className='flex p-2 gap-1 text-left text-sm font-sans w-[80%] border-red-500 rounded-md border mt-4 bg-red-200 items-center'>
                <h1 className="mb-0">¡Error!</h1>
                <p className='mb-0'>{error}</p>
              </div>
            }
            {
              item.active_account ?
                <>
                  <div className='flex font-sans text-sm flex-col my-5 p-2 w-[85%] border-sky-500 text-sky-800 rounded-md border bg-sky-200'>
                    <h1 className="text-left text-lg mb-0 font-bold">Estimado/a {item.nombre + ' ' + item.apellido}</h1>
                    <p className='text-left mb-0'>
                      Hemos verificado que su cuenta se encuentra activada,
                      por favor inicie sesion con sus credenciales
                    </p>
                  </div>
                  <div className='flex gap-2 w-full p-5 justify-center'>
                    <Link to={'/'} className="btn shadow-lg btn-block bg-sky-700 hover:bg-sky-800 hover:duration-75 border-none rounded-md  text-white">
                      <p className='flex items-center gap-1'>
                        Iniciar sesión
                      </p>
                    </Link>
                  </div>
                </>
                :
                procesing ?
                  <div className='flex font-sans text-2xl flex-col p-2 my-5 w-[85%] border-sky-500 text-sky-800 rounded-md border bg-sky-200'>
                    <div className='flex flex-col items-center justify-center'>
                      <span className="loading loading-ring loading-lg"></span>
                      <h1>Activando cuenta...</h1>
                    </div>
                  </div>
                  :
                  message ?
                    <>
                      <div className='flex items-center font-sans my-5 p-2 w-[85%] border-sky-500 text-sky-800 rounded-md border bg-sky-200'>
                        <div className='flex items-center gap-3 text-left '>
                          <FaExclamationCircle size={30} className='text-p-green' />
                           Activación de cuenta exitosa, use sus credenciales para iniciar sesión
                        </div>
                      </div>
                      <div className='flex gap-2 w-full p-5 justify-center'>
                        <Link to={'/'} className="btn shadow-lg btn-block bg-sky-700 hover:bg-sky-800 hover:duration-75 border-none rounded-md  text-white">
                          <p className='flex items-center gap-1'>
                            Iniciar sesión
                          </p>
                        </Link>
                      </div>
                    </>
                    :
                    <div className="w-[85%] md:w-[75%] mx-auto text-gray-700 my-10 font-sans">
                      <div className='flex flex-col gap-3'>
                        <div className="flex flex-col text-start">
                          <p className='text-sky-700 text-[14px]'>ID de usuario:</p>
                          <div className='p-2 bg-gray-400/50 border border-gray-300 rounded-md'>
                            <p>{item.ci_padre}</p>
                          </div>
                        </div>
                        <div className="flex flex-col text-start">
                          <p className='text-sky-700 text-[14px]'>Nombres y Apellidos:</p>
                          <div className='p-2 bg-gray-400/50 border border-gray-300 rounded-md'>
                            <p>{item.nombre + ' ' + item.apellido}</p>
                          </div>
                        </div>
                        <div className="flex flex-col text-start">
                          <p className='text-sky-700 text-[14px]'>Correo electronico:</p>
                          <div className='p-2 bg-gray-400/50 border border-gray-300 rounded-md'>
                            <p>{item.email}</p>
                          </div>
                        </div>
                      </div>
                      <div className='flex w-full justify-center h-[35px] mt-10 gap-2'>
                        <button onClick={onSubmit} type=" submit" className="btn btn-block shadow-lg bg-sky-700 hover:bg-sky-800 hover:duration-75 border-none rounded-md  text-white">
                          Activar cuenta
                        </button>
                      </div>
                    </div>
            }
          </div>
        </div >
      )}
    </>
  );
}
export default ActivateAccountPublic;